"use client"

import type { ReactNode } from "react"
import { openConsentSettings } from "@lib/util/cookie-consent"

export default function CookieSettingsButton({
  className,
  children = "ตั้งค่าคุกกี้",
}: {
  className?: string
  children?: ReactNode
}) {
  return (
    <button
      type="button"
      onClick={() => openConsentSettings()}
      className={className}
      data-testid="cookie-settings-open"
    >
      {children}
    </button>
  )
}